import { connectHook } from 'app/common/components/connect-hook';
import { Confirm } from './confirm';
import { useConfirm } from './confirm-hook';

export default connectHook(Confirm, useConfirm);
